import { cn } from "../../../../lib/utils";
import type { LabTrendChartProps } from "../../types";
import { ChartControls } from "../../molecules/ChartControls";
import { ChartRenderer } from "../../molecules/ChartRenderer";
import { ChartLegend } from "../../molecules/ChartLegend";
import { useTrendChart } from "./useTrendChart";

export const LabTrendChart = ({
  result,
  selectedReadingId,
  onSelectReading,
  className,
  ...props
}: LabTrendChartProps & React.ComponentProps<"div">) => {
  const { chartType, setChartType, timeRange, setTimeRange, chartConfig, handleDataPointClick } = useTrendChart({
    result,
    selectedReadingId,
  });

  const handleChartClick = (data: unknown) => {
    const reading = handleDataPointClick(data);
    if (reading) {
      onSelectReading?.(reading);
    }
  };

  return (
    <div data-slot="lab-trend-chart" className={cn("px-5 py-4", className)} {...props}>
      <ChartControls
        chartType={chartType}
        onChartTypeChange={setChartType}
        timeRange={timeRange}
        onTimeRangeChange={setTimeRange}
      />

      <ChartRenderer
        config={chartConfig}
        resultName={result.name}
        resultUnit={result.readings[0]?.unit ?? ""}
        onDataPointClick={handleChartClick}
      />

      {chartConfig.refRange && (
        <ChartLegend
          refRange={chartConfig.refRange}
          refRangeString={result.readings[0]?.refRange ?? ""}
          unit={result.readings[0]?.unit ?? ""}
        />
      )}
    </div>
  );
};
